<script setup>
import { defineProps, defineEmits} from "vue";
import LinhaDeContasAReceberResumo from "./LinhaDeContasAReceberResumo.vue";
import LinhaDeContasAReceberDetalhes from "./LinhaDeContasAReceberDetalhes.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "contaAReceber",
]);

const emits = defineEmits([
    "update:alteraContaAReceber",
]);

//==================================================================//
//===================== Altera Conta a Receber =====================//
//==================================================================//

const alteraContaAReceber = (update)=>{

    update.id = props?.contaAReceber?.id;
    emits('update:alteraContaAReceber',update);

};

</script>

<template>

    <div class="c-table__row-group">

        <LinhaDeContasAReceberResumo
            :dado="props?.dado"
            :contaAReceber="props?.contaAReceber"
            @update:alteraContaAReceber="alteraContaAReceber"
        ></LinhaDeContasAReceberResumo>

        <LinhaDeContasAReceberDetalhes
            :dado="props?.dado"
            :contaAReceber="props?.contaAReceber"
        ></LinhaDeContasAReceberDetalhes>

    </div>

</template>

<style scoped>

.c-table__row-group{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>